export default __webpack_public_path__ + "static/esg_social_box_d-7a3a5197da28a5ec522533e93cdfc92e.png";